import React, { useEffect, useState } from "react";
import './LoanSchedule.css'
// import { AiFillFilePdf, AiOutlineDownload } from 'react-icons/ai'
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../../../../App";
import Cookies from 'js-cookie';

const LoanSchedule = ({loanData}) => {
const [open, setOpen] = React.useState(false);
const [loanScheduleData, setloanScheduleData] = useState([]);
const token = Cookies.get('Token');
const email = Cookies.get('Email');
// console.log(loanData);

useEffect(() => {
    setOpen(true);
    axios
      .post(url + "/loan/schedule", {
        email: email,
        token: token,
        loan_id: loanData.loan_id,
      })
      .then((res) => {
        setOpen(false);
        // console.log(res);
        if (res.data.auth === false) {
          toast.error(res.data.message);
        } else {
        setOpen(false);
        setloanScheduleData(res.data.message);
      }  
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
      });
  }, [email,token,loanData.loan_id]);

  return (
    <>
        <div className="loan-schedule">
            {/* <div className="loan-schedule-top">
                 <AiOutlineDownload className='ls-dl-btn' />
                <AiFillFilePdf className='ls-pdf-btn' />
                <button className='ls-stc-btn'>Send To Customer</button>
            </div> */}
            <div className="lms-table-div">
                <table className="lms-table loan-schdule">
                    <thead>
                        <tr>
                            <th>Emi Amount</th>
                            <th>Emi Date</th>
                            <th>Emi DPD</th>
                            <th>Emi Status</th>
                            <th>Interest Amount</th>
                            <th>Interest Pending</th>
                            <th>LPC Pending</th>
                            <th>NACH Pending</th>
                            <th>Principal Amount</th>
                            <th>Principal Pending</th>
                            <th>ROC Pending</th>
                        </tr>
                    </thead>
                    <tbody>
                  {loanScheduleData.length > 0 &&
                    loanScheduleData?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{data.emiAmount}</td>
                          <td>{data.emiDate?.slice(0,10)}</td>
                          <td>{data.emiDpd}</td>
                          <td>{data.emiStatus}</td>
                          <td>{data.interestAmount}</td>
                          <td>{data.interestPending}</td>
                          <td>{data.lpcPending}</td>
                          <td>{data.nachPending}</td>
                          <td>{data.principalAmount}</td>
                          <td>{data.principalPending}</td>
                          <td>{data.rocPending}</td>
                        </tr>
                      );
                    })}
                </tbody>
                </table>
            </div>
            <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        </div>
    </>
  )
}

export default LoanSchedule